export class UpdateAdminResult {
    public result: boolean = false;
    public id?: number;
    public platformId?: number;

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }
}
